import QualityMentoringFormPage from './QualityMentoringFormPage';
import QuestionGroup from './QuestionGroup';
import QualityMentoringFormQuestion from './QualityMentoringFormQuestion';
import getPercentComplete from '../FormUtils';
import RestService from 'restService';

declare const API_URL: any;

export default class QualityMentoringForm {
  pages: QualityMentoringFormPage[] = [];

  json: any;

  percentComplete: number = 0;

  readonly questions: QualityMentoringFormQuestion[] = [];

  private static instance: QualityMentoringForm;

  public static schema;

  public static getInstance(): QualityMentoringForm {
    if (!QualityMentoringForm.instance) {
      QualityMentoringForm.instance = new QualityMentoringForm();
    }
    return QualityMentoringForm.instance;
  }

  public static async getSchema() {
    const schema = await RestService.get(`${API_URL}/schema`);
    QualityMentoringForm.schema = schema;
    return schema;
  }

  private constructor() {
    const schema = QualityMentoringForm.schema.data;
    this.json = [
      schema.section1,
      schema.section2,
      schema.section3,
      schema.section4,
      schema.section5,
    ];
    this.json.forEach((row: any) => {
      const page = new QualityMentoringFormPage(row);
      this.questions.push(...page.questions);
      this.pages.push(page);
    });
  }

  getGroups(section: number): QuestionGroup[] {
    return this.pages[section - 1].groups;
  }

  updateMetrics(submission) {
    this.percentComplete = getPercentComplete(this.questions, submission);
    this.pages.forEach((page, pageNumber) => page.updateMetrics(submission, this.questions, pageNumber));
  }
}
